import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useState} from 'react';

import {useFullVariantByIdSsr} from '../../../../api/hooks/useFullVariantByIdSsr.hook';
import {useInstanceDetailPage} from '../../../../api/hooks/useInstanceDetail.hook';
import {VariantImageType} from '../../../../api/models/variant-image-type';
import variables from '../../../../themes/variables.module.scss';
import {ButtonVariantsEnum} from '../../../../utils/_enums/button-variants.enum';
import {TypographyVariantsEnum} from '../../../../utils/_enums/typeography-variants.enum';
import useBreakpoint from '../../../../utils/_hooks/useBreakpoints.hook';
import useFilterAttachments from '../../../../utils/_hooks/useFilterAttachments.hook';
import {Button} from '../../../_shared/button/button';
import {Seperator} from '../../../_shared/seperator/seperator';
import {Spacer} from '../../../_shared/spacer/spacer';
import {Typography} from '../../../_shared/typography/typography';
import {VariantDetailStageMetaBoxAudioVideo} from '../../../variant-detail/variant-detail-stage/variant-detail-stage-meta-box/variant-detail-stage-meta-box-audio-video/variant-detail-stage-meta-box-audio-video';
import {VariantDetailStageMetaBoxKeywords} from '../../../variant-detail/variant-detail-stage/variant-detail-stage-meta-box/variant-detail-stage-meta-box-keywords/variant-detail-stage-meta-box-keywords';
import styles from './instance-detail-stage-meta-box.module.scss';
import { formatDate, isDateInFuture, isDateInPast } from '../../../../utils/_helper/time-helper';
import { useInstanceMetaByMetaUrlSsr } from '../../../../api/hooks/useInstanceMetaByMetaUrlSsr';
import { useAppSelector } from '../../../../utils/_hooks/hooks';
import { InstanceStatus } from '../../../../api/models/instance-status';

export interface Props {
    title: string;
    author: string;
    publisher: string;
    release?: Date;
    copies: string;
    keywords: string[];
    genre: string;
    ownerWallet?: string;
    ownerUsername?: string;
    onButtonClick: any;
}

export const InstanceDetailStageMetaBox: React.FC<Props> & {
    dataHooks?: any;
} = ({title, author, publisher, release, copies, genre, keywords, ownerWallet, ownerUsername, onButtonClick}) => {
    const [openModal, setModal] = useState(false);
    const data = useInstanceDetailPage();
    const breakpoint = useBreakpoint();

    const variant = useFullVariantByIdSsr();

    const samples = useFilterAttachments(VariantImageType.PRODUCT_SAMPLE, variant?.attachments);

    const { instance } = useAppSelector((state) => ({instance: state.productSlice.instance}));
    
    return (
        <>
            <div className={styles['variant-detail-stage-meta-box']}>
                <div className={styles['variant-detail-stage-meta-box-infos']}>
                    <div
                        className={styles['variant-detail-stage-meta-box__keywords']}
                    >
                        {genre && (
                            <VariantDetailStageMetaBoxKeywords
                                key={genre}
                            >
                                {genre}
                            </VariantDetailStageMetaBoxKeywords>
                        )}

                        {breakpoint === 'mobile' ? (
                            <VariantDetailStageMetaBoxKeywords
                                variant="keyword"
                                key={keywords?.[0]}
                            >
                                {keywords?.[0]}
                            </VariantDetailStageMetaBoxKeywords>
                        ) : (
                            keywords?.map((keyword) => (
                                <VariantDetailStageMetaBoxKeywords
                                    variant="keyword"
                                    key={keyword}
                                >
                                    {keyword}
                                </VariantDetailStageMetaBoxKeywords>
                            ))
                        )}
                    </div>

                    <Typography
                        className={styles['instance-title']}
                        variant={
                            breakpoint === 'mobile'
                                ? TypographyVariantsEnum.HEADING3_BOLD
                                : TypographyVariantsEnum.VARIANT_HEADING
                        }
                    >
                        {title}
                    </Typography>

                    <div
                        className={styles['variant-detail-stage-meta-box-body-container']}
                    >

                        <table
                            className={styles['table']}
                        >
                            <tbody>
                                <tr>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_TITLE
                                            }
                                        >
                                            {data?.stageMetaBoxTitleAuthor}:
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_VALUE
                                            }
                                        >
                                            {author}
                                        </Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_TITLE
                                            }
                                        >
                                            {data?.stageMetaBoxTitlePublisher}:
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_VALUE
                                            }
                                        >
                                            {publisher}
                                        </Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_TITLE
                                            }
                                        >
                                            {data?.stageMetaBoxTitleRelease}:
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_VALUE
                                            }
                                        >
                                            {formatDate(release)}
                                        </Typography>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_TITLE
                                            }
                                        >
                                            {data?.stageMetaBoxTitleCopies}:
                                        </Typography>
                                    </td>
                                    <td>
                                        <Typography
                                            variant={
                                                TypographyVariantsEnum.TABLE_VALUE
                                            }
                                        >
                                            {copies}
                                        </Typography>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        {/* {breakpoint === 'mobile' && (ownerUsername || ownerWallet) && (
                            <>
                                <Seperator
                                    color={variables['greys_middleLight']}
                                    width="300px"
                                    height="1px"
                                />
                                <table cellSpacing="10px">
                                    <tbody>
                                    <tr>
                                        <td>
                                            <Typography
                                                variant={TypographyVariantsEnum.TABLE_TITLE}>{data.owner}:</Typography>
                                            <Typography variant={TypographyVariantsEnum.TABLE_VALUE}
                                                        className={styles['owner-wallet-id']}
                                                        element={'span'}>
                                                {ownerUsername ?? ownerWallet}</Typography>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </>
                        )} */}
                    </div>
                </div>
                <div>
                    <div
                        className={styles['button-box']}
                    >
                        <Button
                            onClick={() => setModal(true)}
                            icon={{
                                element: (
                                    <FontAwesomeIcon
                                        icon={['fas', 'play']}
                                    />
                                ),
                                align: 'left'
                            }}
                            variant={ ButtonVariantsEnum.SECONDARY_OUTLINED_FILLED_ICON }
                            className={styles['listen-button']}
                        >
                            {data?.stageFileDescription}
                        </Button>
                        {
                            instance?.status !== InstanceStatus.SOLD ?
                                <Button
                                    onClick={onButtonClick}
                                    icon={{
                                        element: (
                                            <FontAwesomeIcon
                                                icon={['far', 'chevron-down']}
                                            />
                                        ),
                                        align: 'right'
                                    }}
                                    variant={ ButtonVariantsEnum.PRIMARY }
                                    className={styles['listen-button']}
                                    disabled={
                                        instance?.status !== InstanceStatus.OPEN
                                        || isDateInFuture(instance?.variant.salesAttribute.saleFrom)
                                        || (isDateInPast(instance?.variant.salesAttribute.saleTo) && !instance?.ownerId && !ownerWallet)
                                        || isDateInFuture(instance?.saleStartDate)
                                    }
                                >
                                    {data?.buyButton.buttonText}
                                </Button> : undefined
                        }
                    </div>
                </div>
            </div>
            {openModal && (
                <VariantDetailStageMetaBoxAudioVideo
                    type={samples?.[0]?.contentContentType ?? ''}
                    onClose={() => setModal(false)}
                    title={samples?.[0]?.name ?? ''}
                    url={samples?.[0]?.url ?? ''}
                />
            )}
        </>
    );
};
